exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disable-scroll[data-v-33e78fa2]{overflow:hidden!important}.searchBuddyBox[data-v-33e78fa2]{margin:7px 12px 10px!important}.mobileSearchTagsChild[data-v-33e78fa2]{width:100%!important}", ""]);

// exports
